import { useCallback, useEffect, useState } from "react"

import { IApiLink } from "@/types"
import AssetVersion from "models/AssetVersion"
import AssetService from "services/AssetService"

export default function useAssetVersions(linkGetAssetVersions?: IApiLink, onFail?: () => void) {
    const [assetVersions, setAssetVersions] = useState<AssetVersion[] | null>(null)

    const fetchAssetVersions = useCallback(async () => {
        if (!linkGetAssetVersions) {
            setAssetVersions(null)
            return
        }
        try {
            const newAssetVersions = await AssetService.getAssetVersions(linkGetAssetVersions)
            setAssetVersions(newAssetVersions)
        } catch (e) {
            onFail?.()
        }
    }, [linkGetAssetVersions, onFail])

    useEffect(() => {
        fetchAssetVersions()
    }, [fetchAssetVersions])

    return {
        assetVersions,
    }
}
